module.exports = __webpack_public_path__ + "img/scene5-7.3b59ead4.jpg";